import { Component, Input } from '@angular/core';
import { SideBarType } from './../../enums/side-bar-type';

@Component({
  selector: 'plans-side-bar',
  template: require('./plans-side-bar.component.html'),
  styles: [require('./plans-side-bar.component.scss')],
})
export class PlansSideBarComponent {
  public SideBarType = SideBarType;
  displayType: SideBarType;

  constructor() {
  }

  @Input()
  set type(typeToDisplay: string) {
    if (typeToDisplay == 'register') {
      this.displayType = SideBarType.Register;
    } else if (typeToDisplay ==  'upgrade') {
      this.displayType = SideBarType.Upgrade;
    } else {
      this.displayType = SideBarType.Upsell;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/components/plans-side-bar/plans-side-bar.component.ts